import { ConfirmModal } from '@/shared/ui/components';
import { t } from 'ttag';
import { useConfirmActivityModal } from './useConfirmActivityModal';
import type { ConfirmActivityModalProps } from './confirmActivityModal.types';

const ConfirmActivityModal = ({
  isOpen,
  onClickRightButton,
  handleStopStreaming,
}: ConfirmActivityModalProps) => {
  const { state } = useConfirmActivityModal({ isOpen, handleStopStreaming });

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={t`Confirm your activity`}
      question={t`The live ECG is about to stop because you have been inactive for more than 10 minutes. To continue streaming, please confirm your activity by clicking the button below. If there is no response, the streaming will be terminated.`}
      rightButtonName={t`Confirm (${state.time}s)`}
      onClickRightButton={onClickRightButton}
      destroyOnClose
    />
  );
};

export default ConfirmActivityModal;
